export default __webpack_public_path__ + "static/media/ancientsoul.91621e5b.png";